import { render, staticRenderFns } from "./ProductSavingsBadge.vue?vue&type=template&id=707387ea&scoped=true&"
import script from "./ProductSavingsBadge.vue?vue&type=script&lang=js&"
export * from "./ProductSavingsBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProductSavingsBadge.vue?vue&type=style&index=0&id=707387ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707387ea",
  null
  
)

export default component.exports